import { NavLink } from "react-router-dom";
import error404 from "../../assets/error-404.svg";
export default function NotFound() {
    return (
        <main className="flex min-h-[60vh] w-full flex-1 flex-col items-center justify-center px-4 py-12 text-center sm:py-16">
            <div className="flex h-20 w-20 items-center justify-center rounded-3xl bg-primary/10">
                <img
                    src={error404}
                    alt=""
                    className="h-12 w-12"
                />
            </div>
            <h1 className="mt-6 text-2xl font-bold tracking-tight text-foreground sm:text-3xl">
                Page non trouvée
            </h1>
            <p className="mt-3 max-w-md text-sm leading-6 text-muted-foreground sm:text-base">
                Désolé, nous n'avons pas trouvé la page que vous cherchiez.
            </p>
            <NavLink
                to="/"
                className="mt-6 inline-flex min-h-11 items-center justify-center rounded-xl bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground shadow-sm transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            >
                Retour à l'accueil
            </NavLink>
        </main>
    );
}
